import React, { useState } from "react";

function Sikayetler() {
  const [sikayetler, setSikayetler] = useState(
    Array.from({ length: 50 }, (_, i) => ({
      id: i + 1,
      name: `Kullanıcı ${i + 1}`,
      complaint: `Şikayet içeriği ${i + 1}`,
      status: i % 3 === 0 ? "Tamamlandı" : i % 2 === 0 ? "Önemli" : "Beklemede",
      date: `2024-11-${(i % 30) + 1}`,
      comments: [],
      image: `https://via.placeholder.com/150?text=Şikayet+${i + 1}`,
    }))
  );

  const [popupSikayet, setPopupSikayet] = useState(null);
  const [newComment, setNewComment] = useState("");
  const [magnifiedImage, setMagnifiedImage] = useState(null);

  // Sayfalama için state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;

  // Şikayet durumuna göre sıralama
  const sortedSikayetler = [...sikayetler].sort((a, b) => {
    const statusOrder = { Önemli: 1, Beklemede: 2, Tamamlandı: 3 };
    return statusOrder[a.status] - statusOrder[b.status];
  });

  // Sayfa başı ve sonu
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedSikayetler.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(sortedSikayetler.length / itemsPerPage);

  // Şikayet durumu güncelleme
  const handleUpdateStatus = (id, status) => {
    setSikayetler((prev) =>
      prev.map((sikayet) =>
        sikayet.id === id ? { ...sikayet, status } : sikayet
      )
    );
    setPopupSikayet(null);
  };

  // Yorum ekleme
  const handleAddComment = (id, comment) => {
    setSikayetler((prev) =>
      prev.map((sikayet) =>
        sikayet.id === id
          ? { ...sikayet, comments: [...sikayet.comments, comment] }
          : sikayet
      )
    );
    setNewComment("");
  };

  const handleMagnifyImage = (imageUrl) => {
    setMagnifiedImage(imageUrl);
  };

  const closeMagnifiedImage = () => {
    setMagnifiedImage(null);
  };

  return (
    <div className="min-h-screen bg-sky-100 p-8 rounded shadow">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">Şikayetler</h1>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white shadow rounded">
          <thead>
            <tr>
              <th className="px-6 py-3 border-b text-left text-sm font-medium text-gray-700">
                Şikayet ID
              </th>
              <th className="px-6 py-3 border-b text-left text-sm font-medium text-gray-700">
                Kullanıcı Adı
              </th>
              <th className="px-6 py-3 border-b text-left text-sm font-medium text-gray-700">
                Şikayet
              </th>
              <th className="px-6 py-3 border-b text-left text-sm font-medium text-gray-700">
                Tarih
              </th>
              <th className="px-6 py-3 border-b text-left text-sm font-medium text-gray-700">
                Durum
              </th>
              <th className="px-6 py-3 border-b text-left text-sm font-medium text-gray-700">
                Aksiyon
              </th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((sikayet) => (
              <tr key={sikayet.id} className="hover:bg-gray-100">
                <td className="px-6 py-3 border-b text-sm text-gray-700">
                  {sikayet.id}
                </td>
                <td className="px-6 py-3 border-b text-sm text-gray-700">
                  {sikayet.name}
                </td>
                <td className="px-6 py-3 border-b text-sm text-gray-700 truncate">
                  {sikayet.complaint.slice(0, 30)}...
                </td>
                <td className="px-6 py-3 border-b text-sm text-gray-700">
                  {sikayet.date}
                </td>
                <td
                  className={`px-6 py-3 border-b text-sm ${
                    sikayet.status === "Beklemede"
                      ? "text-yellow-500"
                      : sikayet.status === "Önemli"
                      ? "text-red-500"
                      : "text-green-500"
                  }`}
                >
                  {sikayet.status}
                </td>
                <td className="px-6 py-3 border-b text-sm text-blue-500">
                  <button
                    className="hover:underline"
                    onClick={() => setPopupSikayet(sikayet)}
                  >
                    Görüntüle
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Sayfa Değiştirme */}
      <div className="mt-4 flex justify-between items-center">
        <button
          className={`px-4 py-2 rounded ${
            currentPage === 1
              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
              : "bg-blue-500 text-white hover:bg-blue-600"
          }`}
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((prev) => prev - 1)}
        >
          Önceki
        </button>
        <p className="text-gray-700">
          Sayfa {currentPage} / {totalPages}
        </p>
        <button
          className={`px-4 py-2 rounded ${
            currentPage === totalPages
              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
              : "bg-blue-500 text-white hover:bg-blue-600"
          }`}
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage((prev) => prev + 1)}
        >
          Sonraki
        </button>
      </div>

      {/* Şikayet Popup */}
      {popupSikayet && (
  <div
    className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
    onClick={(e) => e.target === e.currentTarget && setPopupSikayet(null)}
  >
    <div className="bg-white p-6 rounded shadow-lg w-[600px] relative">
      <button
        className="absolute top-2 right-2 text-gray-500 hover:text-red-500"
        onClick={() => setPopupSikayet(null)}
      >
        ✖
      </button>
      <h2 className="text-2xl font-bold mb-4 text-gray-800">
        Şikayet #{popupSikayet.id}
      </h2>
      <div className="flex mb-4 gap-4">
      <button className="absolute bg-gray-300 p-2"onClick={() => handleMagnifyImage(popupSikayet.image)}>🔍</button>
        <img
          src={popupSikayet.image}
          alt={`Şikayet ${popupSikayet.id} Görseli`}
          className="w-32 h-32 rounded shadow"
        />
        
        <div>
          <p className="text-gray-700 mb-2">
            <strong>Kullanıcı:</strong> {popupSikayet.name}
          </p>
          <p className="text-gray-700 mb-2">
            <strong>Şikayet:</strong> {popupSikayet.complaint}
          </p>
          <p className="text-gray-700 mb-2">
            <strong>Tarih:</strong> {popupSikayet.date}
          </p>
          <p className="text-gray-700 mb-2">
            <strong>Durum:</strong> {popupSikayet.status}
          </p>
        </div>
      </div>
      <div className="mb-4">
        <strong>Durumu Güncelle:</strong>
        <select
          className="w-full mt-2 p-2 border rounded"
          value={popupSikayet.status}
          onChange={(e) => handleUpdateStatus(popupSikayet.id, e.target.value)}
        >
          <option value="Beklemede">Beklemede</option>
          <option value="Önemli">Önemli</option>
          <option value="Tamamlandı">Tamamlandı</option>
        </select>
      </div>
      <div className="mb-4">
        <strong>Yorumlar:</strong>
        <div className="bg-gray-100 p-2 rounded max-h-32 overflow-y-auto mt-2">
          {popupSikayet.comments.length > 0 ? (
            popupSikayet.comments.map((comment, index) => (
              <p
                key={index}
                className="text-sm text-gray-800 border-b py-1 last:border-none"
              >
                {comment}
              </p>
            ))
          ) : (
            <p className="text-sm text-gray-500">Henüz yorum yok.</p>
          )}
        </div>
      </div>
      <div>
        <input
          type="text"
          className="w-full p-2 border rounded mb-2"
          placeholder="Yeni yorum ekle"
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
        />
        <button
          className="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
          onClick={() =>
            newComment.trim() &&
            handleAddComment(popupSikayet.id, newComment.trim())
          }
        >
          Yorum Ekle
        </button>
      </div>
    </div>
  </div>
)}


      {/* Görsel Büyütme Popup */}
      {magnifiedImage && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50">
          <div className="relative">
            <button
              className="absolute top-2 right-2 text-white text-2xl"
              onClick={closeMagnifiedImage}
            >
              ✖
            </button>
            <img
              src={magnifiedImage}
              alt="Büyütülmüş Görsel"
              className="w-auto h-auto max-w-full max-h-full rounded"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default Sikayetler;
